export default {
  settings: (state) => {
    return state.noticeBar.settings
  },
  settingsTimestamp: (state) => {
    return state.noticeBar.settings?.timestamp
  }
}
